module.exports = __webpack_public_path__ + "img/hotel4.393a5ca6.png";